exports = module.exports = require("../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /drone/~/css-loader!/drone/~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!/drone/~/less-loader/dist/cjs.js?{"modifyVars":{"@tengen-color":"#65aca6","@primary-color":"@tengen-color","@border-radius-base":"3px","@btn-primary-color":"#fff","@btn-primary-bg":"@tengen-color","@btn-default-border":"#ddd","@btn-danger-color":"#fff","@btn-danger-bg":"#d61518","@btn-danger-border":"#d61518","@font-size-base":"14px","@link-color":"@tengen-color","@link-hover-color":"@tengen-color","@link-active-color":"@tengen-color"}}!/drone/~/antd/lib/locale-provider/style/index.less
// module id = 1766
// module chunks = 2